import $ from 'jquery';
import HistoryManager from '../utilities/HistoryManager';
import DocumentsService from '../service/DocumentsService';

const getFilterParameters = () => {
    return HistoryManager.current().getParameters();
};

$('.filter--documents').submit(function (event) {
    event.preventDefault();
    const parameters = getFilterParameters();
    DocumentsService.getItems(parameters)
        .then((response) => {
            if (response.items.length === 0) {
                $('.documents-empty').removeClass('documents-empty--hidden');
                $('.documents-table').addClass('documents-table--hidden');
            } else {
                $('.documents-empty').addClass('documents-empty--hidden');
                $('.documents-table').removeClass('documents-table--hidden');
            }
            DocumentsService.renderItems(response.items);
        });
});
